import moment from 'moment'
import 'moment-timezone'

export const createTime = (hour: string, minute: string): number => (
  (Number(hour) * 60) + Number(minute)
)

export const extractHourToMinutes = (minutes: number): any => {
  if (minutes <= 0) {
    return { hour: 0, minute: 0 }
  }

  if (!minutes) return null

  const hour = Math.floor(minutes / 60)
  const minute = minutes - hour * 60
  return { hour, minute }
}

export const formatDate = (date: string | Date, format: string) => {
  let currentDate = date
  if (typeof date === 'string') {
    currentDate = new Date(date)
  }

  moment.locale('en-US')
  return moment(currentDate).tz('America/Bahia').add(3, 'hours').format(format)
}

export const dateDiff = (
  initialDate: Date,
  lastDate: Date,
) => {
  const miliseconds = initialDate.getTime() - lastDate.getTime()
  const seconds = miliseconds / 1000
  const minutes = seconds / 60

  return Math.abs(Math.round(minutes))
}

export const calculateIntervalFor = (
  initialDate: Date | string | number,
  finishDate: Date | string | number | null,
) => {
  const format = 'YYYY-MM-DD'
  const initialDateObj = moment(new Date(initialDate), format)
  const finishDateObj = moment(finishDate ? new Date(finishDate) : new Date(), format)
  initialDateObj.add(1, 'day')

  const diff = Math.abs(finishDateObj.diff(initialDateObj, 'days'))

  return diff - 1
}
